export default "__VITE_PUBLIC_ASSET__4dbaabb3__"